import React, { useEffect, useRef, useState } from "react";
import styles from "../../../layouts/OnboardLayout/OnboardLayout.module.scss";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../../routes";
import logo from "../../../../assets/logos/text-logo-black.svg";
import { ErrorMessage, Formik, useFormik } from "formik";
import Input from "../../../common/Formik/Input/Input";
import verificationStyles from "./SecurityVerification.module.scss";
import { Link } from "react-router-dom";
import Button from "../../../common/Button/Button";
import { LeftArrowIcon } from "../../../../assets/icons/svgicons";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { Form } from "react-bootstrap";
import OTP from "../../../common/Formik/OTP/OTP";
import {
  forgotEmailVerifyAction,
  generateOTPAction,
} from "../../../../features/user/userSlice";
import {
  FORMIK_REGEX,
  Messages,
  SERVICES,
  SERVICESTYPE,
  isNumber,
} from "../../../../utils/constants";
import { validationMessage } from "../../../../Helper/helperfunction";
import InputFormik from "../../../common/Formik/Input/InputFormik";
import { isOTPVerified } from "../../../../features/persist/persistSlice";
import emailStyles from "../EmailVerification/EmailVerification.module.scss";

const SecurityVerification = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [otp, setOtp] = useState("");
  const signUpData = useSelector((state) => state?.persist?.signUpData);
  const otpVerified = useSelector((state) => state?.persist?.otpVerified);
  const [timer, setTimer] = useState(60);
  const [showBtn, setShowBtn] = useState(false);
  const [resendPending, setResendPending] = useState(false);
  const resendLockRef = useRef(false);

  const validationSchema = Yup.object({
    otp: Yup.string()
      .required(validationMessage("OTP"))
      .matches(FORMIK_REGEX.NUMBER, Messages?.NUMBERVALIDATION),
  });

  const generateOTP = async () => {
    if (resendLockRef.current) return;
    resendLockRef.current = true;
    setResendPending(true);
    const data = {
      username: await signUpData?.username,
      type: SERVICESTYPE?.EMAIL,
      service: SERVICES?.FORGOTPASSWORD,
    };

    try {
      const response = await dispatch(generateOTPAction(data));
      if (response?.status === 200) {
        setTimer(60);
        setShowBtn(false);
      }
    } catch (error) {
      console.log("Something went wrong:", error);
    } finally {
      resendLockRef.current = false;
      setResendPending(false);
    }
  };

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes.toString().padStart(2, "0")}:${seconds
      .toString()
      .padStart(2, "0")}`;
  };

  useEffect(() => {
    let interval;
    if (timer > 0 && !showBtn) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else if (timer === 0) {
      setShowBtn(true);
    }
    return () => clearInterval(interval);
  }, [timer, showBtn]);

  useEffect(() => {
    if (otpVerified) {
      navigate(ROUTES.LOGIN);
    }
  }, []);

  const formik = useFormik({
    initialValues: {
      otp: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      const dataObj = {
        otp: values.otp,
        service: "FORGOTPASSWORD",
        username: await signUpData?.username,
      };
      try {
        const response = await dispatch(forgotEmailVerifyAction(dataObj));
        if (response?.status === 200) {
          dispatch(isOTPVerified(true));
          navigate(ROUTES.RESET_PASSWORD);
        }
      } catch (error) {
        console.log("Something went wrong:", error);
      }
    },
  });

  const handleResend = () => {
    generateOTP();
  };

  return (
    <div
      className={`${styles.onboard_box} ${verificationStyles.verification_box}`}
    >
      <Button
        variant="without_bg_border"
        className="backbtn"
        type="button"
        onClick={() => navigate(-1)}
      >
        <LeftArrowIcon />
        Back
      </Button>
      <h1 className="smallText">Security Verification</h1>
      <p className={`${styles.sub_text} ${verificationStyles.sub_text}`}>
        Please enter the 6-digit verification code that was sent to{" "}
        {signUpData?.username}. The code is valid for 10 minutes.
      </p>
      <Form onSubmit={(e) => { e.preventDefault(); e.stopPropagation(); }}>
        <OTP
          name="otp"
          value={formik.values.otp}
          onChange={(val) => {
            setOtp(val);
            formik.setFieldValue("otp", val); // <-- this line important
          }}
          formik={formik}
          placeholder="------"
        />
        <div className={emailStyles.btn_restotp}>
          {showBtn ? (
            <Button
              className={` ${emailStyles.restBtn}`}
              onClick={handleResend}
              type="button"
              variant="without_bg_border"
              disabled={resendPending}
              loading={resendPending}
            >
              Re send
            </Button>
          ) : (
            <p>Re send verification code in {timer}s</p>
          )}
        </div>
        <div className={`${styles.submit_btn}`}>
          <Button
            fluid
            type="button"
            onClick={(e) => {
              formik.handleSubmit(e);
            }}
            disabled={!(formik.isValid && formik.dirty)}
          >
            Continue
          </Button>
        </div>
        <p className={`${styles.link_text}`}>
          Back to{" "}
          <Link className={styles.bold} to={ROUTES.FORGOT_EMAIL_VERIFICATION}>
            Forgot Password
          </Link>
        </p>
      </Form>
    </div>
  );
};

export default SecurityVerification;
